import React from "react";

import Skeleton, { SkeletonRegion } from "../../../components/Skeleton";

export const SupplierCardSkeleton = () => (
  <li className="home-supplier-row is-skeleton">
    <span className="home-supplier-open">
      <span className="home-supplier-logo">
        <Skeleton variant="block" />
      </span>

      <span className="home-supplier-body">
        <span className="home-supplier-name">
          <Skeleton variant="text" width="68%" height="14px" />
        </span>

        <span className="home-supplier-rating">
          <Skeleton variant="text" width="86px" height="11px" />
        </span>

        <span className="home-supplier-footer">
          <span className="home-supplier-meta">
            <Skeleton variant="text" width="64px" height="11px" />
          </span>

          <span className="home-supplier-price">
            <Skeleton variant="text" width="92px" height="14px" />
          </span>
        </span>
      </span>
    </span>

    <span className="home-supplier-save">
      <Skeleton variant="circle" width="18px" height="18px" />
    </span>
  </li>
);

const SupplierSkeleton = ({ rows = 5 }) => (
  <SkeletonRegion label="Finding suppliers nearby">
    <ul className="home-panel-list">
      {Array.from({ length: rows }, (_, index) => (
        <SupplierCardSkeleton key={`home-supplier-skeleton-${index}`} />
      ))}
    </ul>
  </SkeletonRegion>
);

export default SupplierSkeleton;
